export default "__VITE_ASSET__cbdd5b8a__"